/**
 * Partner tags from auth API (user.tags); any match grants partner-only access.
 */
export const PARTNER_TAGS = ['impartner', 'cs_employee'] as const;

const PARTNER_TAG_SET = new Set<string>(PARTNER_TAGS);

export interface UserWithTags {
  tags?: string[] | null;
}

/** Module-private: hasPartnerTag() below is the only entry point the app uses. */
function userTagsIncludePartnerTag(userTags: string[] | null | undefined): boolean {
  return (
    Array.isArray(userTags) &&
    userTags.some((t) => typeof t === 'string' && PARTNER_TAG_SET.has(t))
  );
}

export function hasPartnerTag(user: UserWithTags | null | undefined): boolean {
  return userTagsIncludePartnerTag(Array.isArray(user?.tags) ? user.tags : null);
}
